import React, { useState } from "react";
import { SAdefaultValues } from "./accountingRPT-services";
import {
  Button,
  colors,
  Container,
  Grid,
  LinearProgress,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import AccountingRPTForm from "./accountingRPT-form";
import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import {
  useStylesUiElemment,
} from "../../../../St/Reports/UseStyle";
import BalanceCard from "../../../../components/BalanceCard";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { TableChart } from "@material-ui/icons";
import axios from "axios";
import AccountsSumTable from "./AccountSumTable";
import AccountsRPTTable from "./AccountsRPTTable";
import InvoicesDialogs from "../../../Invs/BackEnd/Invoices/InvoicesDialogs";
import EReceiptVoucherDialog from "../receipt-voucher/external-receipt-voucher/EReceiptVoucherDialog";
import EExchangeVoucherDialog from "../receipt-voucher/external-exchange-voucher/EExchangeVoucherDialog";
import IExchangeVoucherDialog from "../receipt-voucher/internal-exchange-voucher/IExchangeVoucherDialog";
import ReceiptVoucherDialog from "../receipt-voucher/internal-receipt-voucher/ReceiptVoucherDialog";
// import ORestrictionsDialog from "../opening-restrictions/ORestrictionsDialog";
import { MultiQabdDataDialog, MultiSarfDataDialog } from "../receipt-voucher/multi-receipt-voucher/MVCon";
import RestrictionDailogCon from "../Restriction/RestrictionDailogCon";
import RestInfoDialog from "../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { GetItemFromOptions } from "../../../../services/multi-receipt-services";
import RevAccounting from "../../../../Reviews/Accounts/Balance/RevAccounting";
import { exportExcelReport } from "../../../../components/ExcelExport";
import AccountingRPTTableItems, { groupTransactions } from "./accountingRPTTableItems";
import { sto } from "../../../../Context/InshData";
import { convertToTreeData } from "../../../../services/accountIndex-services";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    borderColor: "#808080",
    textAlign: "center",
    fontSize: 20,
    width: "100%",
    fontWeight: "bold"
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
}));
export const excelHeadersAccount = [
  { label: "الرصيد", key: "balance" },
  { label: "مدين", key: "dept" },
  { label: "دائن", key: "credit" },
  { label: "رقم المستند", key: "doc_no" },
  { label: "مركز التكلفة", key: "centerName" },
  { label: "التاريخ", key: "date" },
  { label: "نوع المستند", key: "type" },
  { label: "رقم المرجع", key: "ref_no" },
  { label: "البيان", key: "notes" },
];
export default function AccountingRPT(props) {
  const { AutoOptions } = props;
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";

  const typePrint = [
    { id: 0, label: "افتراضي", key: "balance" },
    { id: 1, label: "مصادقة حـساب", key: "dept" },
    { id: 3, label: "WithItems", key: "dept" },
  ];
  const [rptParams, setRptParams] = React.useState({
    ...SAdefaultValues,
    dateFrom: from_date,
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    account: AutoOptions.Accindex[0],
    typePrint: typePrint[0],
  });
  const [accounts, setAccounts] = useState([]);
  const changeType = async (x) => {
    setRptParams({ ...rptParams, selectTypeSearch: x });
    if (accounts.length === 0) {
      await downloadAccount();
    }
  };

  const downloadAccount = async () => {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = "accounts-index/getAll"
    } else {
      Urls = `accounts-index/getAll?db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setAccounts(convertToTreeData(res.data));
      })
      .catch((err) => {
        setAccounts([]);
      });
  };


  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const [dataExcel, setDataExcel] = useState([]);
  const [dataItems, setDataItems] = useState([]);
  const [dataTotals, setDataTotals] = useState({});
  const [invData, setInvData] = useState({});
  const [accountsName, setAccountsName] = useState({});
  const [fetching, setFetching] = useState(false);
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const datas = AutoOptions?.Datas ?? [];
  const [database, setDatabase] = useState(datas.find((obj) => obj.name == sto.db_name));
  const [infoData, setInfoData] = useState({ open: false, rest_id: 0, branch: 0 });
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };

  const viewHandle = async () => {
    setDataExcel([]);
    setDataItems([]);
    setDataTotals({});
    setFetching(true);
    if (rptParams.typePrint.id == 3) {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/rptAccBalanceItems?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
      } else {
        Urls = `AccountReports/rptAccBalanceItems?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          setDataItems(res.data.AccountBalance);
          // setDataItems(groupTransactions(res.data.AccountBalance));
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          setFetching(false);
          console.log(err);
          setDataTotals({});
          setDataItems([]);
          // toast.err("يوجد خطأ في الجلب");
        });

    }
    else if (rptParams.selectType.id == 1) {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/rptAccBalance?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
      } else {
        Urls = `AccountReports/rptAccBalance?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}&&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}&&orderType=${rptParams.orderType.id}&&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          setFetching(false);
          console.log(err);
          setDataTotals({});
          setDataExcel([]);
          // toast.err("يوجد خطأ في الجلب");
        });
    }
    else {
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/AccountsSumDataMulti?type=${rptParams.type?.id}
    &&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}
    &&acc_code=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account?.id}&&old=${rptParams?.oldBalance}
    &&open=${rptParams?.openBalance}`
      } else {
        Urls = `AccountReports/AccountsSumDataMulti?type=${rptParams.type?.id}
        &&branch=${rptParams.branch.id}&&center=${rptParams.center?.id}&&dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}
        &&acc_code=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account?.id}&&old=${rptParams?.oldBalance}
        &&open=${rptParams?.openBalance}&&db_name=${database?.name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          // setData(res.data);
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          viewHandleOld();
        });
    }
  };
  const viewHandleOld = async () => {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `AccountReports/AccountsSumData?type=${rptParams.type?.id}
&&branch=${rptParams.branch.id}
&&center=${rptParams.center?.id}
&&dateFrom=${rptParams.dateFrom}
&&dateTo=${rptParams.dateTo}
&&acc_code=${rptParams.account?.id}`
    } else {
      Urls = `AccountReports/AccountsSumData?type=${rptParams.type?.id}
&&branch=${rptParams.branch.id}
&&center=${rptParams.center?.id}
&&dateFrom=${rptParams.dateFrom}
&&dateTo=${rptParams.dateTo}
&&acc_code=${rptParams.account?.id}&&db_name=${database?.name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        const dataItems = res.data.AccountBalance.map((row, i) => {
          return {
            ...row,
            no: i + 1,
            centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
          };
        });
        setDataExcel(dataItems);
        setDataTotals(res.data.totals);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        setDataTotals({});
        setDataExcel([]);
      });
  };
  const his = useHistory();
  const toBack = () => {
    his.push({ pathname: "/" });
  };
  const printHandle = () => {
    if (dataExcel.length == 0 && rptParams.typePrint.id != 3) return;
    if (dataItems.length == 0 && rptParams.typePrint.id === 3) return;
    const info = {
      data: rptParams.typePrint.id === 3 ? dataItems : dataExcel,
      tot: dataTotals,
      from: "الحساب",
      title: "حركة حساب خلال فترة",
      auto: {},
      account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      balance: parseFloat(dataTotals?.totBlncDept ?? 0)
        - parseFloat(dataTotals?.totBlncCredit ?? 0),
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: false,
      typePrint: rptParams.typePrint?.id,
      db_name: database?.name
    };
    if (rptParams.typePrint.id == 3) {
      setDataPrint(info);
      setInfoPrint(true);
    }
    else if (rptParams.typePrint.id == 1 && rptParams?.selectTypeSearch?.id == 1) {
      printHandleConfirm();
    } else {
      if (rptParams.selectType.id == 1) {
        setDataPrint(info);
        setInfoPrint(true);
      } else {
        printHandleSum();
      }
    }
  };

  const printHandleConfirm = () => {
    const info = {
      balance: parseFloat(dataTotals?.totBlncDept ?? 0)
        - parseFloat(dataTotals?.totBlncCredit ?? 0),
      from: "الحساب",
      title: "طلب مصادقة حـساب",
      auto: {},
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      date: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: true,
      db_name: database?.name
    };
    setDataPrint(info);
    setInfoPrint(true);
  };
  const printHandleSum = () => {
    const info = {
      data: dataExcel,
      tot: dataTotals,
      type: rptParams?.type?.id,
      kind_print: "2",
      title: "حركة حساب خلال فترة",
      title: "حركة حساب خلال فترة",
      account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
      fDate: rptParams?.dateFrom,
      tDate: rptParams?.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      db_name: database?.name

    };
    localStorage.setItem('iInfos', JSON.stringify(info));
    his.push({ pathname: "/CustBalance", state: info });
    window.location.reload(false);
  };
  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    if (propName === "db_name") {
      setDatabase(newValue);
    } else {
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  const [isOpenInv, setIsOpenInv] = useState(false);
  const [isOpenSandQ, setIsOpenSandQ] = useState(false);
  const [isOpenSandS, setIsOpenSandS] = useState(false);
  const [isOpenSandSD, setIsOpenSandSD] = useState(false);
  const [isOpenSandQD, setIsOpenSandQD] = useState(false);
  const [isOpenDailyRest, setIsOpenDailyRest] = useState(false);
  const [isOpenFirstRest, setIsOpenFirstRest] = useState(false);
  const [isOpenMultiSarf, setIsOpenMultiSarf] = useState(false);
  const [isOpenMultiQbd, setIsOpenMultiQbd] = useState(false);



  const [allow, setAllow] = useState({ inv: false, sqbd: false, sandQD: false, ssrf: false, sandSD: false, dailyRes: false, FirstRest: false, multiSarf: false, multiQbd: false });
  const handleOpenInvData = () => {
    setAllow({ ...allow, inv: !isOpenInv });
    setIsOpenInv(!isOpenInv);
  }; // E rsa

  const handleOpenSandQData = () => {
    setAllow({ ...allow, sqbd: !isOpenSandQ });
    setIsOpenSandQ(!isOpenSandQ);
  }; // E rsa
  const handleOpenSandSData = () => {
    setAllow({ ...allow, ssrf: !isOpenSandS });
    setIsOpenSandS(!isOpenSandS);
  }; // E rsa
  const handleOpenSandSDData = () => {
    setAllow({ ...allow, sandSD: !isOpenSandSD });
    setIsOpenSandSD(!isOpenSandSD);
  }; // E rsa
  const handleOpenSandQDData = () => {
    setAllow({ ...allow, sandQD: !isOpenSandQD });
    setIsOpenSandQD(!isOpenSandQD);
  }; // E rsa
  const handleOpenDailyRest = () => {
    setAllow({ ...allow, dailyRes: !isOpenDailyRest });
    setIsOpenDailyRest(!isOpenDailyRest);
  }; // E rsa
  const handleOpenFirstRest = () => {
    setAllow({ ...allow, FirstRest: !isOpenFirstRest });
    setIsOpenFirstRest(!isOpenFirstRest);
  }; // E rsa
  const handleOpenMultiSarf = () => {
    setAllow({ ...allow, multiSarf: !isOpenMultiSarf });
    setIsOpenMultiSarf(!isOpenMultiSarf);
  }; // E rsa

  const handleOpenMultiQbd = () => {
    setAllow({ ...allow, multiQbd: !isOpenMultiQbd });
    setIsOpenMultiQbd(!isOpenMultiQbd);
  };

  const Export_excel = () => {
    if (rptParams.selectType.id == 1) {
      exportExcelReport({
        title: "كشف حساب" + "  " + "من تاريخ" + "  :" + rptParams.dateFrom + "  " + "إلى تاريخ" + "   :" + rptParams.dateTo,
        // companyName: "شركة OraxCloud",
        // fromDate: rptParams.dateFrom,
        // toDate: rptParams.dateTo,
        info: [
          {
            label: "من تاريخ",
            value: rptParams.dateFrom
          },
          {
            label: "إلى تاريخ",
            value: rptParams.dateTo
          },
          {
            label: "اسم الحساب",
            value: rptParams.account?.name ?? ""
          },
          {
            label: "رقم الحساب",
            value: rptParams.account.id
          },
          {
            label: "الفرع",
            value: rptParams.branch.name
          },
        ],

        columns: [
          {
            title: "م",
            field: "__index",
            width: 7
          },
          {
            title: "البيان",
            field: "notes",
            width: 40
          },
          {
            title: "رقم المرجع",
            field: "ref_no",
            // width: 18
          },
          {
            title: "نوع المستند",
            field: "type",
            // width: 15
          },
          {
            title: "مركز التكلفة",
            field: "centerName",
            // width: 15
          },
          {
            title: "التاريخ",
            field: "date",
            // width: 15,
            type: "date"
          },
          {
            title: "رقم المستند",
            field: "doc_no",
            // width: 12
          },
          {
            title: "مدين",
            field: "dept",
            // width: 18,
            type: "number"
          },
          {
            title: "دائن",
            field: "credit",
            // width: 18,
            type: "number"
          },
          {
            title: "الرصيد",
            field: "balance",
            // width: 18,
            type: "number"
          }
        ],

        data: dataExcel,

        totals: [
          {
            label: "إجمالي المدين",
            field: "debt"
          },
          {
            label: "إجمالي الدائن",
            field: "credit"
          }
        ],

        fileName: "كشف_حساب",

        sheetName: "كشف الحساب",

        showSerial: false,

        showFilter: true,

        freezeHeader: true,

        rightToLeft: true
      });
    } else {
      exportExcelReport({
        title: "كشف حساب" + "  " + "من تاريخ" + "  :" + rptParams.dateFrom + "  " + "إلى تاريخ" + "   :" + rptParams.dateTo,
        // companyName: "شركة OraxCloud",
        // fromDate: rptParams.dateFrom,
        // toDate: rptParams.dateTo,
        info: [
          {
            label: "من تاريخ",
            value: rptParams.dateFrom
          },
          {
            label: "إلى تاريخ",
            value: rptParams.dateTo
          },
          // {
          //   label: "اسم الحساب",
          //   value: rptParams.account?.name??""
          // },
          // {
          //   label: "رقم الحساب",
          //   value:  rptParams.account.id
          // },
          {
            label: "الفرع",
            value: rptParams.branch.name
          },
        ],
        columns: [
          {
            title: "م",
            field: "__index",
            width: 7
          },
          {
            title: "رقم الحساب",
            field: "Code",
            width: 15
          },
          {
            title: "الحساب",
            field: "aname",
            width: 18
          },
          {
            title: "مدين (افتتاحي)",
            field: "open_dept",
            width: 18
          },
          {
            title: "دائن (افتتاحي)",
            field: "open_credit",
            width: 18,
            type: "number"
          },
          {
            title: "مدين (سابق)",
            field: "OBX_Dept",
            width: 18,
            type: "number"
          },
          {
            title: "دائن (سابق)",
            field: "OBX_Credit",
            width: 15,
            type: "number"
          },
          {
            title: "مدين (حركة)",
            field: "dept",
            width: 15,
            type: "number"
          },
          {
            title: "دائن (حركة)",
            field: "credit",
            width: 18,
            type: "number"
          },
          {
            title: "مدين (رصيد)",
            field: "end_Dept",
            width: 18,
            type: "number"
          },
          {
            title: "دائن (رصيد)",
            field: "end_Credit",
            width: 18,
            type: "number"
          }
        ],

        data: dataExcel,

        totals: [
          {
            label: "إجمالي المدين",
            field: "end_Dept"
          },
          {
            label: "إجمالي الدائن",
            field: "end_Credit"
          }
        ],

        fileName: "كشف_حساب",

        sheetName: "كشف الحساب",

        showSerial: false,

        showFilter: true,

        freezeHeader: true,

        rightToLeft: true
      });
    }

  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("acc-move-period")}
        </Typography>
      </Grid>
      <Typography component="div" style={{ direction: "rtl" }}>
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            borderBottomColor: colors.indigo[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <AccountingRPTForm
            {...{
              AutoOptions,
              rptParams,
              setRptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
              accounts,
              setAccountsName,
              accountsName,
              typePrint,
              database,
              changeType
            }}
          />
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1}>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                color="primary"
                size="large"
                className={clasui.buttonAcc}
                // onClick={() => fetchURL()}
                onClick={() => viewHandle()}
              >
                {t("view")}{" "}
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={clasui.buttonAcc}
                onClick={printHandle}
              >
                {t("print")}{" "}
              </Button>
            </Grid>
            {dataExcel.length > 0 &&
              <Grid item>
                <Button
                  disabled={fetching}
                  variant="contained"
                  startIcon={<TableChart />}
                  color="primary"
                  size="large"
                  className={clasui.buttonAcc}
                  onClick={Export_excel}
                >
                  {t("excel_export")}{" "}
                </Button>
              </Grid>}

            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                style={{ background: "#b71c1c" }}
                className={clasui.button}
                onClick={toBack}
              >
                {t("exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={4} md={4} sm={4} xs={6}>
              {rptParams.selectType.id == 1 ?
                (<BalanceCard
                  {...{
                    title: t("acc-peroid-balance"),
                    dept: dataTotals?.totBlncDept ?? 0,
                    credit: dataTotals?.totBlncCredit ?? 0,
                  }}
                />)
                : (<BalanceCard
                  {...{
                    title: t("acc-peroid-balance"),
                    dept: dataTotals?.totEndDept ?? 0,
                    credit: dataTotals?.totEndCredit ?? 0,
                  }}
                />)}

            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={6}>
              {rptParams.selectType.id == 1 ?
                (<BalanceCard
                  {...{
                    title: t("acc-peroid-total"),
                    dept: dataTotals?.totDept ?? 0,
                    credit: dataTotals?.totCredit ?? 0,
                  }}
                />) : (<BalanceCard
                  {...{
                    title: t("acc-peroid-total"),
                    dept: dataTotals?.totDept ?? 0,
                    credit: dataTotals?.totCredit ?? 0,
                  }}
                />)}
            </Grid>
          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            marginTop: "0.4rem"
          }}
        >
          <Grid container>
            {rptParams.typePrint.id == 3 ?
              (fetching ? (
                <Paper>
                  {t("please-wait-fetch-data")}
                  <LinearProgress />
                </Paper>
              ) : (
                <AccountingRPTTableItems
                  {...{
                    data: dataItems ? groupTransactions(dataItems) : [], fromPrint: false, setInvData, handleOpenInvData, handleOpenSandQData, handleOpenSandSData
                    , handleOpenSandSDData, handleOpenSandQDData, handleOpenDailyRest, handleOpenFirstRest,
                    handleOpenMultiSarf, handleOpenMultiQbd, infoData, setInfoData, AutoOptions
                  }}
                />
              ))
              :
              <> {rptParams.selectType.id == 1 ?
                (fetching ? (
                  <Paper>
                    {t("please-wait-fetch-data")}
                    <LinearProgress />
                  </Paper>
                ) : (
                  <AccountsRPTTable
                    {...{
                      data: dataExcel ? dataExcel : [], setInvData, handleOpenInvData, handleOpenSandQData, handleOpenSandSData
                      , handleOpenSandSDData, handleOpenSandQDData, handleOpenDailyRest, handleOpenFirstRest,
                      handleOpenMultiSarf, handleOpenMultiQbd, infoData, setInfoData, AutoOptions, db_name: database?.name
                    }}
                  />
                )) :
                (fetching ? (
                  <Paper>
                    {t("please-wait-fetch-data")}
                    <LinearProgress />
                  </Paper>
                ) : (
                  <AccountsSumTable {...{ data: dataExcel ? dataExcel : [] }} />
                ))}
              </>}
          </Grid>

        </Container>
        {
          allow.inv ? (
            <InvoicesDialogs
              open={isOpenInv}
              onClose={() => {
                setIsOpenInv(false);
              }}
              onSave={() => {
                setIsOpenInv(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}
        {
          allow.sqbd ? (
            <EReceiptVoucherDialog
              open={isOpenSandQ}
              onClose={() => {
                setIsOpenSandQ(false);
              }}
              onSave={() => {
                setIsOpenSandQ(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}
        {
          allow.ssrf ? (
            <EExchangeVoucherDialog
              open={isOpenSandS}
              onClose={() => {
                setIsOpenSandS(false);
              }}
              onSave={() => {
                setIsOpenSandS(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}
        {
          allow.sandSD ? (
            <IExchangeVoucherDialog
              open={isOpenSandSD}
              onClose={() => {
                setIsOpenSandSD(false);
              }}
              onSave={() => {
                setIsOpenSandSD(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}

        {
          allow.sandQD ? (
            <ReceiptVoucherDialog
              open={isOpenSandQD}
              onClose={() => {
                setIsOpenSandQD(false);
              }}
              onSave={() => {
                setIsOpenSandQD(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}
        {
          allow.dailyRes ? (
            <RestrictionDailogCon
              open={isOpenDailyRest}
              onClose={() => {
                setIsOpenDailyRest(false);
              }}
              onSave={() => {
                setIsOpenDailyRest(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}

        {
          allow.multiSarf ? (
            <MultiSarfDataDialog
              open={isOpenMultiSarf}
              onClose={() => {
                setIsOpenMultiSarf(false);
              }}
              onSave={() => {
                setIsOpenMultiSarf(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}

        {
          allow.multiQbd ? (
            <MultiQabdDataDialog
              open={isOpenMultiQbd}
              onClose={() => {
                setIsOpenMultiQbd(false);
              }}
              onSave={() => {
                setIsOpenMultiQbd(false);
              }}
              invData={invData}
              db_name={database?.name}
            />
          ) : null}
        {infoData.open &&
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={infoData.rest_id}
            branch={infoData.branch}
            fromInv={0}
            proc_id={0}
            db_name={database?.name}
          />
        }
        {infoPrint ? <RevAccounting dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
      </Typography>
    </div>
  );
}
